import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { User, ShoppingBag, Download } from 'lucide-react';

const Dashboard = () => {
  // This will be replaced with real user data after authentication is implemented
  const isLoggedIn = false;

  if (!isLoggedIn) {
    return (
      <div className="min-h-screen bg-black">
        <Navbar />
        <div className="pt-24 px-4 sm:px-6 lg:px-8 pb-20 flex items-center justify-center min-h-[80vh]">
          <Card className="bg-gradient-to-br from-purple-900/20 to-blue-900/20 border-white/10 max-w-md w-full">
            <CardContent className="p-8 text-center">
              <User className="mx-auto mb-4 text-purple-400" size={64} />
              <h2 className="text-2xl font-bold text-white mb-4">Login Required</h2>
              <p className="text-gray-400 mb-6">
                Please log in or create an account to access your dashboard.
              </p>
              <div className="space-y-3">
                <Link to="/login">
                  <Button className="w-full bg-purple-600 hover:bg-purple-700 text-white">
                    Log In
                  </Button>
                </Link>
                <Link to="/signup">
                  <Button variant="outline" className="w-full border-white/20 text-white hover:bg-white/10">
                    Sign Up
                  </Button>
                </Link>
              </div>
            </CardContent>
          </Card>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <div className="pt-24 px-4 sm:px-6 lg:px-8 pb-20">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-8">Dashboard</h1>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
            <Card className="bg-gradient-to-br from-purple-900/20 to-blue-900/20 border-white/10">
              <CardContent className="p-6">
                <ShoppingBag className="text-purple-400 mb-4" size={32} />
                <h3 className="text-2xl font-bold text-white mb-2">0</h3>
                <p className="text-gray-400">Total Orders</p>
              </CardContent>
            </Card>
            
            <Card className="bg-gradient-to-br from-purple-900/20 to-blue-900/20 border-white/10">
              <CardContent className="p-6">
                <Download className="text-purple-400 mb-4" size={32} />
                <h3 className="text-2xl font-bold text-white mb-2">0</h3>
                <p className="text-gray-400">Downloads Available</p>
              </CardContent>
            </Card>
          </div>

          <Card className="bg-gradient-to-br from-gray-900/50 to-gray-800/50 border-white/10">
            <CardContent className="p-8 text-center">
              <p className="text-gray-400 text-lg">No orders yet. Browse our products to get started!</p>
              <Link to="/products">
                <Button className="mt-4 bg-purple-600 hover:bg-purple-700 text-white">
                  View Products
                </Button>
              </Link>
            </CardContent>
          </Card>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Dashboard;